import BaseText from '../BaseText';

const H1Text = (props) => {
  return (
    <BaseText
      as={'h1'}
      font={'light'}
      size={'96px'}
      spacing={-1.5}
      {...props}
    />
  );
};
H1Text.displayName = 'H1Text';

const H2Text = (props) => {
  return (
    <BaseText
      as={'h1'}
      font={'light'}
      size={'60px'}
      spacing={-0.5}
      {...props}
    />
  );
};
H2Text.displayName = 'H2Text';

const H3Text = (props) => {
  return (
    <BaseText as={'h3'} font={'regular'} size={'48px'} spacing={0} {...props} />
  );
};
H3Text.displayName = 'H3Text';

const H4Text = (props) => {
  return (
    <BaseText
      as={'h4'}
      font={'regular'}
      size={'34px'}
      spacing={0.25}
      {...props}
    />
  );
};
H4Text.displayName = 'H4Text';

const H5Text = (props) => {
  return (
    <BaseText as={'h5'} font={'regular'} size={'24px'} spacing={0} {...props} />
  );
};
H5Text.displayName = 'H5Text';

const H6Text = (props) => {
  return (
    <BaseText
      as={'h6'}
      font={'regular'}
      size={'20px'}
      spacing={0.15}
      {...props}
    />
  );
};
H6Text.displayName = 'H6Text';

const Subtitle1Text = (props) => {
  return (
    <BaseText
      as={'p'}
      font={'regular'}
      size={'16px'}
      spacing={0.15}
      {...props}
    />
  );
};
Subtitle1Text.displayName = 'Subtitle1Text';

const Subtitle2Text = (props) => {
  return (
    <BaseText as={'p'} font={'medium'} size={'14px'} spacing={0.1} {...props} />
  );
};
Subtitle2Text.displayName = 'Subtitle2Text';

const Body1Text = (props) => {
  return (
    <BaseText
      as={'p'}
      font={'regular'}
      size={'16px'}
      spacing={0.5}
      {...props}
    />
  );
};
Body1Text.displayName = 'Body1Text';

const Body2Text = (props) => {
  return (
    <BaseText
      as={'p'}
      font={'regular'}
      size={'14px'}
      spacing={0.25}
      {...props}
    />
  );
};
Body2Text.displayName = 'Body2Text';

const ButtonText = (props) => {
  return (
    <BaseText
      as={'span'}
      font={'light'}
      size={'14px'}
      spacing={0.75}
      uppercase={true}
      {...props}
    />
  );
};
ButtonText.displayName = 'ButtonText';

const CaptionText = (props) => {
  return (
    <BaseText
      as={'span'}
      font={'regular'}
      size={'12px'}
      spacing={0.4}
      {...props}
    />
  );
};
CaptionText.displayName = 'CaptionText';

const OverlineText = (props) => {
  return (
    <BaseText
      as={'span'}
      font={'regular'}
      size={'10px'}
      spacing={1.5}
      uppercase={true}
      {...props}
    />
  );
};
OverlineText.displayName = 'OverlineText';

export {
  H1Text,
  H2Text,
  H3Text,
  H4Text,
  H5Text,
  H6Text,
  Subtitle1Text,
  Subtitle2Text,
  ButtonText,
  Body1Text,
  Body2Text,
  CaptionText,
  OverlineText,
};
